import z from "zod"
import { AppThunk } from "../appStore"
import { selectFusionApiAxios } from "../selectAxios"
import { onlineHttpError } from "./handleApiError"
import { setLdng } from "../appSlice"
import { syncHttpReq, SyncHttpReqConfig } from "@fusion-advantage/formrender"
import { appError } from "../errorSlice"
import { err, ok, Result } from "neverthrow"
import { safeParseJson, serializeFusionError } from "@fusion-advantage/backcompat"

export const ZApiMgrTokenEchoBody = z.object({
	Token: z.string(),
})
type ApiMgrTokenEchoBody = z.infer<typeof ZApiMgrTokenEchoBody>

export const apiMgrTokenEcho = (): AppThunk<Promise<Result<ApiMgrTokenEchoBody, void>>> => async (dispatch, getState) => { 
	dispatch(setLdng({apiMgrTokenEcho: true}))
	const axInst = selectFusionApiAxios(getState())
	const cfg: SyncHttpReqConfig = {
		axInst,
		method: 'GET',
		url: '/api/v0/mgr/token-echo',
	}
	const r = await syncHttpReq(cfg)
	dispatch(setLdng({apiMgrTokenEcho: false}))
	if(r.isErr()) {
		dispatch(appError(onlineHttpError(cfg, r.error, {})))
		return err()
	}
	const rParse = safeParseJson(r.value.data, ZApiMgrTokenEchoBody)
	if(rParse.isErr()) {
		dispatch(appError({
			err: serializeFusionError('apiMgrTokenEcho', rParse.error)
		}))
		return err()
	}
	return ok(rParse.value)
}

export const apiDevDestroyEncounters = (): AppThunk<Promise<Result<void, void>>> => async (dispatch, getState) => {
	dispatch(setLdng({apiDevDestroyEncounters: true}))
	const axInst = selectFusionApiAxios(getState())
	const cfg: SyncHttpReqConfig = {
		axInst,
		method: 'GET',
		url: '/api/v0/mgr/dev-destroy-encounters',
	}
	const r = await syncHttpReq(cfg)
	dispatch(setLdng({apiDevDestroyEncounters: false}))
	if(r.isErr()) {
		dispatch(appError(onlineHttpError(cfg, r.error, {})))
		return err()
	}
	return ok()
}
